import React from 'react';
import { Alert, Empty } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { VariablesTabProps } from '../types.d';
import { TEST_EMAIL_MODAL_CONSTANTS } from '../constants';
import { isValidJSON, parseTestData, formatVariableValue } from '../utils/helpers';
import {
  FormSection,
  PreviewTitle,
  BadgeContainer,
  BadgeStyled,
  DividerStyled,
  VariableItem,
  VariableKey,
  VariableValue,
  AlertBox,
} from '../styles';

const VariablesTab: React.FC<VariablesTabProps> = ({ template, testData }) => {
  return (
    <FormSection>
      <Alert
        message="Template Variables"
        description={TEST_EMAIL_MODAL_CONSTANTS.HELP_TEXTS.VARIABLES_INFO}
        type="info"
        icon={<InfoCircleOutlined />}
        style={{ marginBottom: 16 }}
      />

      {template?.variables && template.variables.length > 0 ? (
        <>
          <div>
            <PreviewTitle>{TEST_EMAIL_MODAL_CONSTANTS.HELP_TEXTS.AVAILABLE_VARIABLES}</PreviewTitle>
            <BadgeContainer>
              {template.variables.map((variable, index) => (
                <BadgeStyled key={index}>{variable}</BadgeStyled>
              ))}
            </BadgeContainer>
          </div>
          <DividerStyled />
        </>
      ) : (
        <>
          <Empty description={TEST_EMAIL_MODAL_CONSTANTS.HELP_TEXTS.NO_VARIABLES} />
          <DividerStyled />
        </>
      )}

      <div>
        <PreviewTitle>{TEST_EMAIL_MODAL_CONSTANTS.HELP_TEXTS.CURRENT_TEST_DATA}</PreviewTitle>
        {isValidJSON(testData) ? (
          <div>
            {Object.entries(parseTestData(testData) || {}).map(([key, value]) => (
              <VariableItem key={key}>
                <VariableKey>{`{{${key}}}`}</VariableKey>
                <VariableValue>{formatVariableValue(value)}</VariableValue>
              </VariableItem>
            ))}
          </div>
        ) : (
          <AlertBox type="error">
            {TEST_EMAIL_MODAL_CONSTANTS.HELP_TEXTS.INVALID_JSON_VARIABLES}
          </AlertBox>
        )}
      </div>
    </FormSection>
  );
};

export default VariablesTab;
